import { useEffect, useState } from 'react';

export function useSessionStorage<T>(
  key: string,
  initialValue: T,
  excludeKeys: string[] = [],
) {
  const [value, setValue] = useState<T>(() => {
    try {
      const stored = sessionStorage.getItem(key);
      return stored ? JSON.parse(stored) : initialValue;
    } catch (error) {
      return initialValue;
    }
  });

  useEffect(() => {
    try {
      let valueToStore = value;

      // Aplica filtro de exclusão APENAS se:
      // 1. Há chaves para excluir
      // 2. O valor é um objeto plano (não null, não array, não primitivo)
      if (
        excludeKeys.length > 0 &&
        value !== null &&
        typeof value === 'object' &&
        !Array.isArray(value)
      ) {
        valueToStore = Object.keys(value).reduce(
          (acc, currentKey) => {
            if (!excludeKeys.includes(currentKey)) {
              acc[currentKey] = (value as Record<string, any>)[currentKey];
            }
            return acc;
          },
          {} as Record<string, any>,
        ) as T;
      }

      sessionStorage.setItem(key, JSON.stringify(valueToStore));
    } catch (error) {
      // Ignore errors
    }
  }, [key, value, excludeKeys]);

  return [value, setValue] as const;
}
